import { gql } from '__generated__'

export const SUBSCRIPTION_ACTIVE_USERS = gql(`
  subscription online {
    online
  }
`)
